import apiClient from '../utils/apiClient';

// Get entitlements for an employee
export const getEmployeeEntitlements = async (employeeId, params = {}) => {
  const response = await apiClient.get(`api/leave-entitlements/${employeeId}`, { params });
  return response.data;
};

// Create a new entitlement
export const createEntitlement = async (data) => {
  const response = await apiClient.post('api/leave-entitlements', data);
  return response.data;
};

// Update an entitlement
export const updateEntitlement = async (entitlementId, data) => {
  const response = await apiClient.put(`api/leave-entitlements/${entitlementId}`, data);
  return response.data;
};

// Delete an entitlement
export const deleteEntitlement = async (entitlementId) => {
  const response = await apiClient.delete(`api/leave-entitlements/${entitlementId}`);
  return response.data;
};

// Generate default entitlements for an employee
export const generateDefaultEntitlements = async (employeeId, data = {}) => {
  const response = await apiClient.post(`api/leave-entitlements/${employeeId}/generate-defaults`, data);
  return response.data;
};

// Get company-wide leave summary
export const getCompanyLeaveSummary = async (params = {}) => {
  const response = await apiClient.get('api/leave-entitlements/company-summary', { params });
  return response.data;
};

// Add days or set carry over for several people; pass { restore } to undo.
export const batchUpdateEntitlements = async (body) => {
  const response = await apiClient.patch('api/leave-entitlements/batch', body);
  return response.data;
};
